module.exports = __webpack_public_path__ + "img/background_c4-2_mobile.1b382a79.jpg";